import './Passengers.scss';
import logo from '../../assets/icons/alpha_taxis_logo.svg';
import Button from '../../common/Button/Button';
import Text from '../../common/Text/Text';
import useBooking from '../../hooks/useBooking/useBooking';
import { useNavigate } from 'react-router';

const Passengers = () => {
  const { passengers, setPassengers } = useBooking();
  const navigate = useNavigate();

  const handleContinue = () => {
    navigate('/receipt') as void;
  };

  return (
    <div className="passengers">
      <img src={logo} className="logo" />
      <div className="content">
        <Text type="header">How many Passengers?</Text>
        <Button
          buttonStyleType={passengers === 4 ? 'primary' : 'secondary'}
          label="1 to 4"
          handleClick={() => setPassengers(4)}
          customStyling={{ width: '100%' }}
          customClassName="option"
        />
        <div className="button-group">
          <Button
            buttonStyleType={passengers === 5 ? 'primary' : 'secondary'}
            label="5"
            handleClick={() => setPassengers(5)}
            customStyling={{ flex: 1 }}
            customClassName="option"
          />
          <Button
            buttonStyleType={passengers === 6 ? 'primary' : 'secondary'}
            label="6"
            handleClick={() => setPassengers(6)}
            customStyling={{ flex: 1 }}
            customClassName="option"
          />
        </div>
        <div className="button-group">
          <Button
            buttonStyleType={passengers === 7 ? 'primary' : 'secondary'}
            label="7"
            handleClick={() => setPassengers(7)}
            customStyling={{ flex: 1 }}
            customClassName="option"
          />
          <Button
            buttonStyleType={passengers === 8 ? 'primary' : 'secondary'}
            label="8"
            handleClick={() => setPassengers(8)}
            customStyling={{ flex: 1 }}
            customClassName="option"
          />
        </div>
        <Button
          buttonStyleType="primary"
          label="Continue"
          handleClick={handleContinue}
          customStyling={{ width: '100%' }}
          disabled={!passengers}
        />
        <hr />
      </div>
    </div>
  );
};

export default Passengers;
